import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../../../../components/AppIcon';

const ScheduleTemplateCard = ({ template, isSelected, onClick, onViewDetails, variant = 'grid' }) => {
  const { t } = useTranslation();

  if (variant === 'list') {
    return (
      <div
        onClick={onClick}
        className={`px-4 py-3 cursor-pointer transition-colors flex items-center gap-4 ${
          isSelected ? 'bg-primary/5 border-s-4 border-primary' : 'hover:bg-muted'
        }`}
      >
        <div
          className="w-3 h-3 rounded-full flex-shrink-0"
          style={{ backgroundColor: template?.color }}
        ></div>

        <div className="min-w-0 flex-1">
          <div className="font-semibold text-foreground text-sm truncate">
            {template?.name}
          </div>
          {template?.description ? (
            <div className="text-xs text-muted-foreground truncate">
              {template?.description}
            </div>
          ) : null}
        </div>

        <div className="hidden sm:block w-28 text-xs text-muted-foreground truncate">
          {template?.type || ''}
        </div>

        <div className="hidden sm:block w-20 text-xs text-muted-foreground truncate text-end">
          {template?.status === 'Inactive'
            ? t('Inactive', { defaultValue: 'Inactive' })
            : t('Active', { defaultValue: 'Active' })}
        </div>

        <div className="w-32 text-xs text-muted-foreground flex items-center justify-end gap-2">
          <span>{t('Assigned Employees')}:</span>
          <span className="font-medium text-foreground">
            {template?.stats?.totalUsers || template?.assignedUsers?.length || 0}
          </span>
        </div>

        <button
          onClick={(e) => {
            e?.stopPropagation();
            onViewDetails?.();
          }}
          className="text-muted-foreground hover:text-foreground transition-colors flex-shrink-0"
          title={t('Details')}
        >
          <Icon name="Eye" size={16} />
        </button>
      </div>
    );
  }

  return (
    <div
      onClick={onClick}
      className={`p-4 rounded-lg border-2 cursor-pointer transition-all ${
        isSelected
          ? 'border-primary bg-primary/5 shadow-md'
          : 'border-border hover:border-border hover:shadow-sm'
      }`}
    >
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-center gap-2 flex-1">
          <div
            className="w-3 h-3 rounded-full flex-shrink-0"
            style={{ backgroundColor: template?.color }}
          ></div>
          <h4 className="font-semibold text-foreground text-sm line-clamp-1">
            {template?.name}
          </h4>
        </div>
        <button
          onClick={(e) => {
            e?.stopPropagation();
            onViewDetails?.();
          }}
          className="text-muted-foreground hover:text-foreground transition-colors flex-shrink-0"
        >
          <Icon name="Eye" size={16} />
        </button>
      </div>
      <p className="text-xs text-muted-foreground mb-3 line-clamp-2">
        {template?.description}
      </p>
      <div className="space-y-2">
        <div className="flex items-center justify-between text-xs">
          <span className="text-muted-foreground">{t('Assigned Employees')}:</span>
          <span className="font-medium text-foreground">
            {template?.stats?.totalUsers || template?.assignedUsers?.length}
          </span>
        </div>
        <div className="flex items-center justify-between text-xs">
          <span className="text-muted-foreground">{t('Status', { defaultValue: 'Status' })}:</span>
          <span className="font-medium text-foreground">
            {template?.status === 'Inactive'
              ? t('Inactive', { defaultValue: 'Inactive' })
              : t('Active', { defaultValue: 'Active' })}
          </span>
        </div>
      </div>
    </div>
  );
};

export default ScheduleTemplateCard;